import { useState, useEffect, useMemo } from 'react'
import PanelCarsLoading from "components/Result/Skeleton/PanelCarsLoading"
import BannerEvent from "components/Customs/Banner/Horizontal/BannerEvent"
import ModalValidation from 'components/Result/Modal/ModalValidation'
import PanelDetailCar from "components/Result/Cars/PanelDetailCar"
import PanelDetailCarSalfa from "components/Result/Cars/PanelDetailCarSalfa"
import MenuSortDesktop from 'components/Result/MenuSortDesktop'
import AlertSearchingCar from 'components/Result/Scheduled/AlertSearchingCar'
import MediaQuery from 'react-responsive'
import { useDispatch } from 'react-redux'
import { useModal } from 'hooks/useModal'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
const PanelViewRight = ({
    listResultCar = [],
    handleQuoteCar,
    actionAdvertising,
    isLoadingResult,
    getFileCar,
    goToConcesionaire,
    addCompareCar,
    titleHeader,
    menuSort,
    setMenuSort,
    countResult
}) => {
    const { isOpen, closeModal } = useModal(false)
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1)
    const carsPerPage = 15
    const [autos, setAutos] = useState([])  // Autos cargados desde API
    const [error, setError] = useState(null)
    const { pathname } = useLocation()

    const Paginador = () => {
        if (isLoadingResult || totalPagesCombinado <= 1) return null

        const buttons = []
        const total = totalPagesCombinado
        const current = currentPage

        if (total <= 7) {
            for (let i = 1; i <= total; i++) buttons.push(i)
        } else {
            buttons.push(1)
            let left = current - 1
            let right = current + 1

            if (current <= 3) {
                left = 2
                right = 4
            } else if (current >= total - 2) {
                left = total - 3
                right = total - 1
            }

            if (left > 2) buttons.push('left-ellipsis')

            for (let i = left; i <= right; i++) {
                if (i > 1 && i < total) buttons.push(i)
            }

            if (right < total - 1) buttons.push('right-ellipsis')

            buttons.push(total)
        }


        return (
            <div className="pagination mt-4 d-flex justify-content-center gap-2">
                {buttons.map((page, idx) => {

                    if (page === 'left-ellipsis' || page === 'right-ellipsis') {
                        return <span key={page + idx} className="pagination-ellipsis">...</span>
                    }

                    return (
                        <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`btn btn-sm ${currentPage == page ? 'active' : ''}`}
                        >
                            {page}
                        </button>
                    )
                })}

            </div>
        )
    }




    // Resetear página al cambiar resultados props
    useEffect(() => {
        setCurrentPage(1)
    }, [listResultCar])

    // 1. Eliminar duplicados en listResultCar (props)
    const cleanListResultCar = useMemo(() => {
        const map = new Map()
        listResultCar.forEach(car => {
            const uniqueId = car.id || car.key || `${car.model}-${car.price}-${car.year}-${car.color}`
            if (!map.has(uniqueId)) {
                map.set(uniqueId, car)
            }
        })
        return Array.from(map.values())
    }, [listResultCar])

    // 2. Filtrar, ordenar desc por precio y desempate por modelo
    const autosOrdenados = useMemo(() => {
        return cleanListResultCar
            .filter(car => !car.isBanner && Number(car.price) > 0)
            .sort((a, b) => {
                const priceDiff = Number(b.price) - Number(a.price)
                if (priceDiff !== 0) return priceDiff
                return (a.model || '').localeCompare(b.model || '')
            })
    }, [cleanListResultCar])
    //console.log(autosOrdenados, 'aaaaa')
    // 3. Banners separados
    const banners = useMemo(() => cleanListResultCar.filter(car => car.isBanner), [cleanListResultCar])
    // console.log(autosOrdenados)
    const itemsForm = useSelector(state => state.search.itemsForm);
    const isCarUsed = itemsForm?.vTypeAuto?.[0] === 'car-used'

    // 4. Fetch autos desde API una vez al montar
    useEffect(() => {
        if (itemsForm?.vTypeAuto?.[0] === 'car-used') {
            const fetchAutos = async () => {
                try {
                    const response = await fetch('https://prod.movicenter.cl/api/v1/stock/portales/sucursal/1447', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ /* datos necesarios aquí si aplica */ }),
                    })

                    if (!response.ok) throw new Error('Error al obtener los datos')

                    const data = await response.json()

                    // Normalizamos arrays para comparación case-insensitive
                    const marcasFiltro = (itemsForm.vMarca || []).map(m => m.toLowerCase())
                    const modelosFiltro = (itemsForm.vModelo || []).map(m => m.toLowerCase())
                    const carroceriasFiltro = (itemsForm.vCarroceria || []).map(c => c.toLowerCase())
                    const combustiblesFiltro = (itemsForm.vCombustible || []).map(c => c.toLowerCase())
                    const transmisionFiltro = (itemsForm.vTransmision || []).map(t => t.toLowerCase())
                    const originFiltro = (itemsForm.vOrigin || []).map(o => o.toLowerCase())
                    const performanceFiltro = (itemsForm.vPerformance || []).map(p => p.toLowerCase())
                    const seatMoveFiltro = (itemsForm.vSeatMove || []).map(s => s.toLowerCase())
                    const tractionFiltro = (itemsForm.vTraction || []).map(t => t.toLowerCase())
                    if (
                        (originFiltro.length > 0) ||
                        (seatMoveFiltro.length > 0) ||
                        (performanceFiltro.length > 0)
                    ) {
                        // Tu API no tiene esos campos, por tanto ningún auto los tiene, retorno vacío
                        setAutos([])
                        return
                    }
                    const autosFiltrados = data.filter(auto => {
                        // Marca
                        if (marcasFiltro.length > 0 && !marcasFiltro.includes((auto.nombreMarca || '').toLowerCase())) return false

                        // Modelo
                        if (modelosFiltro.length > 0 && !modelosFiltro.includes((auto.nombreModelo || '').toLowerCase())) return false

                        // Carrocería
                        if (carroceriasFiltro.length > 0 && !carroceriasFiltro.includes((auto.carroceria || '').toLowerCase())) return false

                        // Combustible
                        if (combustiblesFiltro.length > 0 && !combustiblesFiltro.includes((auto.combustibleNombre || '').toLowerCase())) return false

                        // Transmisión
                        if (transmisionFiltro.length > 0 && !transmisionFiltro.includes((auto.transmisionNombre || '').toLowerCase())) return false

                        // Traction
                        if (tractionFiltro.length > 0 && !tractionFiltro.includes((auto.traccion || '').toLowerCase())) return false

                        // Precio rango
                        if (itemsForm.vTypeRange) {
                            const minPrecio = itemsForm.vTypeRange.min ?? 0
                            const maxPrecio = itemsForm.vTypeRange.max ?? Infinity
                            if (Number(auto.precio) < minPrecio || Number(auto.precio) > maxPrecio) return false
                        }

                        // Año rango
                        if (itemsForm.vTypeYear) {
                            const minAnio = itemsForm.vTypeYear.min ?? 0
                            const maxAnio = itemsForm.vTypeYear.max ?? 9999
                            if (Number(auto.year) < minAnio || Number(auto.year) > maxAnio) return false
                        }

                        // KM rango
                        if (itemsForm.vTypeKm) {
                            const minKm = itemsForm.vTypeKm.min ?? 0
                            const maxKm = itemsForm.vTypeKm.max ?? Infinity
                            if (Number(auto.kms) < minKm || Number(auto.kms) > maxKm) return false
                        }

                        return true
                    })

                    setAutos(autosFiltrados)
                } catch (err) {
                    console.error('Error al obtener autos:', err)
                    setError(err.message)
                }
            }
            fetchAutos()
        }
    }, [itemsForm])



    // Helpers para obtener precio y modelo normalizados
    const getPrecio = car => Number(car.price ?? car.precio ?? 0)
    const getModelo = car => (typeof car.model === 'object' ? car.model.name ?? '' : car.model ?? '')

    // 5. Unir y ordenar autos props + autos API, eliminar duplicados
    const autosCombinadosOrdenados = useMemo(() => {
        const etiquetadosProps = autosOrdenados.map(auto => ({ ...auto, source: 'props' }))
        const etiquetadosAPI = autos.map(auto => ({ ...auto, source: 'api' }))
        const combinados = [...etiquetadosProps, ...etiquetadosAPI]

        const map = new Map()
        combinados.forEach(car => {
            const uniqueId = car.id || car.key || `${getModelo(car)}-${getPrecio(car)}-${car.year}-${car.color}`
            if (!map.has(uniqueId)) map.set(uniqueId, car)
        })
        return Array.from(map.values())
            .filter(car => getPrecio(car) > 0)
            .sort((a, b) => {
                const diff = getPrecio(b) - getPrecio(a)
                if (diff !== 0) return diff
                return getModelo(a).localeCompare(getModelo(b))
            })
    }, [autosOrdenados, autos])

    // 6. Total páginas combinado
    const totalPagesCombinado = Math.ceil(autosCombinadosOrdenados.length / carsPerPage)

    // 7. Autos combinados para página actual
    const autosCombinadosPagina = useMemo(() => {
        const start = (currentPage - 1) * carsPerPage
        return autosCombinadosOrdenados.slice(start, start + carsPerPage)
    }, [autosCombinadosOrdenados, currentPage])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' }) // o 'auto' si no quieres animación
    }, [currentPage])

    return (
        <div className="col-xs-12 col-md-9">
            {/* Título y contador */}
            <div className="search-result">
                <div>
                    <h1 className="search-result__title">{titleHeader}</h1>
                    {isCarUsed ? (
                        <p className="search-result__small">
                            {(autos.length > 0 && listResultCar.length > 0)
                                ? `${autosCombinadosOrdenados.length} Resultados`
                                : 'Cargando resultados...'}
                        </p>
                    ) : (
                        <p className="search-result__small">
                            {(autosOrdenados.length > 0)
                                ? `${autosOrdenados.length} Resultados`
                                : 'Cargando resultados...'}
                        </p>
                    )}


                </div>

                {/* Opcional: menú de ordenar */}
                {/* <MediaQuery minWidth={768}>
                    <div className="options-search__container">
                        <p
                            className="options-search__type options-search--order d-none d-md-block"
                            onClick={() => setMenuSort(!menuSort)}
                            style={{ cursor: 'pointer' }}
                        >
                            Ordenar
                        </p>
                        {menuSort && <MenuSortDesktop setMenuSort={setMenuSort} />}
                    </div>
                </MediaQuery> */}
            </div>
            <Paginador />

            {/* Listado de autos y banners */}
            <div className="card-cars-flex">
                {!isLoadingResult && autosCombinadosPagina.length > 0 && (
                    <>
                        {autosCombinadosPagina.map((item, index) => {
                            const key = item.key || item.id || `${item.model}-${item.price}-${item.color}-${item.year}`

                            if (item.source === 'api' && isCarUsed) {
                                return (
                                    <PanelDetailCarSalfa
                                        key={`salfa-${item.key || index}`}
                                        item={item}
                                        addCompareCar={addCompareCar}
                                        viewCar={getFileCar}
                                        handleQuoteCar={handleQuoteCar}
                                        goToConcesionaire={goToConcesionaire}
                                    />
                                )
                            }

                            return (
                                <PanelDetailCar
                                    key={key}
                                    {...item}
                                    idKey={item?.key}
                                    listado={[]}
                                    addCompareCar={addCompareCar}
                                    viewCar={getFileCar}
                                    handleQuoteCar={handleQuoteCar}
                                    goToConcesionaire={goToConcesionaire}
                                    consesionaire={item.concessionaire}
                                />
                            )
                        })}


                        {/* Renderizado de banners */}
                        {banners.map((bannerItem, idx) => (
                            <BannerEvent
                                key={`banner-${idx}`}
                                imagen={bannerItem.banners}
                                functionModal={actionAdvertising}
                                title="Banner"
                                classContainer="mb-0"
                                classPicture="mb-0 car-banner__detail banner-result"
                                classMain="banner-num__result"
                            />
                        ))}
                    </>
                )}

                {/* Skeleton loading */}
                {isLoadingResult && Array.from({ length: 5 }).map((_, i) => (
                    <PanelCarsLoading key={`skeleton-${i}`} />
                ))}
            </div>

            {/* Sin resultados */}
            {!isLoadingResult && autosCombinadosPagina.length === 0 && (
                <div className="error_not_search mt-5">
                    <img src="https://api-news.movicenter.cl/misc/no-encontrado.png" alt="No hay búsqueda" />
                </div>
            )}

            {/* Paginador */}
            {!isLoadingResult && totalPagesCombinado > 1 && (
                <Paginador />
            )}

            {/* Modal validación */}
            {isOpen && <ModalValidation isOpen={isOpen} closeModal={closeModal} />}
        </div>
    )
}

export default PanelViewRight
